export default "/img/MD.9b569e54a1965f61bd79b92f0bedeea2.png";